<!-- eslint-disable vue/html-self-closing -->
<template>
  <div
    class="copy-commit-hash input-group input-group-sm flex-nowrap"
    :class="{ '--small': isSmall }"
  >
    <input
      :id="inputId"
      ref="clipboardInput"
      type="hidden"
      :value="textToCopy"
    />
    <span
      class="copy-commit-hash__hash form-control bg-light"
      :class="{ 'bg-white': isWhiteBackground }"
    >
      {{ text }}
    </span>
    <div class="input-group-append rounded">
      <button
        type="button"
        class="d-flex align-items-center btn btn-outline-dark copy-commit-hash__copy"
        :class="{ 'bg-white': isWhiteBackground }"
        @click="
          copyText();
          toggleAnimation();
        "
      >
        <i class="gf-icon gf-icon-copy"></i>
        <span
          class="clipboard__tooltip f6"
          :class="{ visible: isVisibleTooltip }"
          data-tooltip-text="Скопировано!"
        ></span>
      </button>
    </div>
  </div>
</template>
<script>
export default {
  name: 'GfCopyCommitHash',
  props: {
    text: {
      type: String,
      default: '',
      required: true
    },
    textToCopy: {
      required: true,
      type: String,
      default: null
    },
    inputId: {
      type: String,
      default: 'clipboardId'
    },
    isSmall: {
      type: Boolean,
      default: false
    },
    isWhiteBackground: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isVisibleTooltip: false
    };
  },
  methods: {
    copyText() {
      if (window.isSecureContext && navigator.clipboard) {
        navigator.clipboard.writeText(this.textToCopy);
      } else {
        this.$refs.clipboardInput.select();
        try {
          document.execCommand('copy');
        } catch (err) {
          console.log(err);
        }
      }
    },
    toggleAnimation() {
      this.isVisibleTooltip = true;
      setTimeout(() => {
        this.isVisibleTooltip = false;
      }, 2500);
    }
  }
};
</script>
<style lang="scss">
$this: '.copy-commit-hash';

#{$this} {
  height: fit-content;
  width: auto !important;

  #{$this}__hash {
    font-size: 0.75rem !important;
    font-family: 'JetBrains Mono', monospace;
    border-top-left-radius: 0.4rem !important;
    border-bottom-left-radius: 0.4rem !important;
    width: 75px;
    text-align: center;
    padding: 6.5px;
    align-content: center;
  }

  #{$this}__copy {
    font-size: 0.75rem !important;
  }

  .clipboard__tooltip {
    position: relative;

    &::before {
      content: attr(data-tooltip-text);
      position: absolute;

      bottom: 2rem;
      left: -2.5rem;

      padding: 0.35rem;
      border-radius: 0.25rem;
      background: var(--black);
      color: #fff;
      text-align: center;

      display: none;
      opacity: 0;
    }

    &::after {
      content: '';
      position: absolute;

      bottom: 1.25rem;

      border: 0.4rem solid var(--black);
      border-color: var(--black) transparent transparent transparent;

      display: none;
      opacity: 0;
    }
  }

  .visible,
  .visible::before,
  .visible::after {
    display: block;
    opacity: 1;
    animation: fadeInOut 2s ease-in-out forwards;
  }

  @keyframes fadeInOut {
    0% {
      opacity: 0;
    }
    5% {
      opacity: 1;
    }
    90% {
      opacity: 1;
    }
    100% {
      opacity: 0;
    }
  }
}

#{$this}.--small {
  #{$this}__hash {
    height: 22px;
    min-height: 22px;
    padding: 0 !important;
  }
  #{$this}__copy {
    min-height: 22px !important;
    padding: 0 4px;

    & > i {
      font-size: 16px;
    }
  }

  .clipboard__tooltip {
    position: relative;

    &::before {
      bottom: 18px;
      left: -56px;
    }

    &::after {
      bottom: 6px;
      right: 2px;
    }
  }
}
</style>
